import React from 'react';
import { logos } from '../assets';
import { LogoProps } from '../types/types';

const Logo: React.FC<LogoProps> = ({
  size = 'medium',
  variant = 'primary',
  className = '',
  style = {},
  invert = false,
}) => {
  const sizeMap = {
    small: { width: '60px', height: 'auto' },
    medium: { width: '120px', height: 'auto' },
    large: { width: '180px', height: 'auto' },
    xl: { width: '240px', height: 'auto' },
  };

  const logoStyle = {
    ...sizeMap[size],
    filter: invert ? 'brightness(0) invert(1)' : 'none',
    ...style,
  };

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    try {
      // Logo failed to load
    } catch (error) {
      // Logo failed to load
    }
    // Fallback to text if image fails
    e.currentTarget.style.display = 'none';
  };

  return (
    <img
      src={logos[variant]}
      alt="DES Logo"
      className={className}
      style={logoStyle}
      onError={handleError}
    />
  );
};

export default Logo;
